import { render, staticRenderFns } from "./ClientPage.vue?vue&type=template&id=3a1ba32e&scoped=true&"
import script from "./ClientPage.vue?vue&type=script&lang=js&"
export * from "./ClientPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientPage.vue?vue&type=style&index=0&id=3a1ba32e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1ba32e",
  null
  
)

export default component.exports